import {
  Target,
  Users,
  Cpu,
  Sliders,
  Sparkles,
  TrendingUp,
  Database,
  HeartHandshake,
  DollarSign,
  HelpCircle,
  ShieldCheck,
  Clock,
  Layers,
  Building,
  UserCheck,
  CheckCircle2,
} from "lucide-react";

export const QUICK_VIEW_STRATEGIES = [
  { label: "Get More Sales Opportunities", icon: TrendingUp },
  { label: "Hone in on Your Target Market", icon: Target },
  { label: "Identify Buyer Personas", icon: Users },
  { label: "Use Technology to Increase Efficiency", icon: Cpu },
  { label: "Get Customized Solutions", icon: Sliders },
  { label: "Innovate for Better Results", icon: Sparkles },
  { label: "Improve Lead Quality", icon: CheckCircle2 },
  { label: "Find Accurate Data", icon: Database },
  { label: "Nurture Your Leads", icon: HeartHandshake },
  { label: "Hit Revenue Goals", icon: DollarSign },
];

export const ROI_DELIVERY_APPROACHES = [
  {
    title: "Pay with Real Help: Fixed Price Model",
    desc: "Predictable, transparent budget management without hidden surprises or fluctuating retainers.",
    icon: DollarSign,
  },
  {
    title: "Quotes with Survey Questions",
    desc: "Qualifying discovery queries that uncover immediate business pain points before calls occur.",
    icon: HelpCircle,
  },
  {
    title: "Role- & Technology-Based Instructions",
    desc: "Reduce overhead through qualified conversations, accelerating ROI for technical solutions.",
    icon: Cpu,
  },
  {
    title: "Suppression Management & Compliance",
    desc: "Active safeguarding against conflicting prospect touches and unwanted domain interference.",
    icon: ShieldCheck,
  },
  {
    title: "3 Months of Exclusive Leads",
    desc: "Dates and prospect opportunities remain 100% exclusive to the advertiser for a full 90-day cycle.",
    icon: Clock,
  },
  {
    title: "Direct Access to Decision-Makers",
    desc: "Bypass gatekeepers to present your value proposition directly to verified C-suite leaders and influencers.",
    icon: UserCheck,
  },
  {
    title: "Basic & Behavioral Segmentation",
    desc: "Multi-layered firmographic and technographic classification tailored to your market criteria.",
    icon: Layers,
  },
  {
    title: "Dedicated Monthly In-House Team",
    desc: "Create and scale an outsourced, loyal extension of your enterprise sales force month over month.",
    icon: Building,
  },
];

export const BOTTOM_FEATURE_COLUMNS = [
  {
    id: "lead-gen",
    title: "Leading Generation",
    subtitle: "High-Volume Calibrated Outreach",
    points: [
      "Quality leads per month",
      "MQL, and SQL lead generation",
      "Unbound quality assurance",
      "Suppression handling",
    ],
  },
  {
    id: "suppression",
    title: "Suppression Handling",
    subtitle: "Pristine Account Protection",
    points: [
      "Suppressing custom advertisers",
      "Custom agency suppression",
      "3 months of unique leads",
      "Flexible deletion policy",
    ],
  },
  {
    id: "scope",
    title: "Target Group Scope",
    subtitle: "Expansive Global Footprint",
    points: [
      "50 million B2B contacts",
      "Facility-based coverage",
      "Specific Department Targeting",
      "Driven by function and technology",
    ],
  },
];